import React from 'react'
import Navbar from '../Home/Navbar'
import Banner from './Banner'

function AllContact() {
  return (
    <div>
        <Navbar/> 
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <Banner/>
    </div>
  )
}

export default AllContact